(function ($) {
    const faces = document.querySelectorAll('.bucket-face');
    const contents = document.querySelectorAll('.bucket-content');

    faces.forEach((face, index) => {
        face.addEventListener('click', () => {
            const target = contents[index];
            const isActive = face.classList.contains('active');

            // Minimize if already active
            if (isActive) {
                face.classList.remove('active');
                target.classList.remove('active');
                return;
            }

            // Activate new bucket
            faces.forEach(f => f.classList.remove('active'));
            face.classList.add('active');

            contents.forEach(c => c.classList.remove('active'));
            target.classList.add('active');

            if (window.innerWidth < 992) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });



    document.querySelectorAll('.bucket-content').forEach(contentDiv => {
        const postId = contentDiv.dataset.postId;

        if (!postId) return;

        fetch(`${ajax_localize.ajax_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `action=get_bucket_post_content&post_id=${postId}&nonce=${ajax_localize.nonce}`
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    contentDiv.innerHTML = data.data;
                } else {
                    contentDiv.innerHTML = '<p>Error loading content.</p>';
                }
            })
            .catch(() => {
                contentDiv.innerHTML = '<p>Request failed.</p>';
            });
    });


})(jQuery);
